import React from 'react';
import { VegaLite } from 'react-vega';

import {
  type HighConfidenceChartAskApiResponse,
  type SampleDataChartResponse,
} from '../../../../data-layer/types';

interface PlotChartProps {
  data: HighConfidenceChartAskApiResponse | SampleDataChartResponse;
}

export default function PlotChart({ data }: PlotChartProps) {
  const spec = {
    ...data.chartSpec,
    data: { name: 'data' }, // Data name as required by Vega-Lite
  };

  return <VegaLite spec={spec} data={{ data: data.content }} />;
}
